import styled from 'styled-components';
export const TableHeaderWrapper = styled.div `
  display: ${({ filtering }) => filtering ? 'contents' : 'table'}; // piece of magic
  width: 100%;
  table-layout: fixed;
  ${({ actionsColumnWidth }) => {
    if (actionsColumnWidth) {
        return `th {
        :last-of-type {
          width: calc(${actionsColumnWidth}px)!important;
          box-sizing: content-box !important;
          } 
        }
      }`;
    }
}}
`;
export const NoRecordsToDisplayTD = styled.td `
  text-align: center;
  line-height: 49px;
  border-bottom: 1px solid #e0e0e0;
`;
export const TableActionsColumn = styled.div `
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
